import React, { useState } from 'react';
import { Link } from "react-router-dom";
import './MobileNavbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faChevronDown } from '@fortawesome/free-solid-svg-icons';

interface MobileNavbarProps {
  logo: string;
  subLogo: string;
  links: LinkItem[];
}

interface LinkItem {
  label: string;
  path: string;
  subLinks?: LinkItem[];
}

const MobileNavbar: React.FC<MobileNavbarProps> = ({ logo, subLogo, links }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  }

  const toggleDropdown = (name: string) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  return (
    <header className={"mobile-navbar"}>
      <div className="navbar-header">
        <Link to="/" onClick={() => setIsMenuOpen(false)}>
        <div className="mobile-logo">{logo}</div>
        <div className="mobile-sublogo">{subLogo}</div>
        </Link>
        <button className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} size="lg" />
        </button>
      </div>
      {/* Overlay */}
      <div className={`overlay ${isMenuOpen ? 'visible' : ''}`} onClick={toggleMenu}></div>
      {/* Menu */}
      <nav className={`menu ${isMenuOpen ? "open" : "closed"}`}>
        <ul>
          {links.map((link) => (
            <li key={link.label} className={`menu-item ${openDropdown === link.label ? 'open' : ''}`}>
              {link.subLinks ? (
                <>
                  <div className="menu-item-header" onClick={() => toggleDropdown(link.label)}>
                    <div className="menu-item-link">
                      {link.label}
                    </div>
                    <span className="dropdown-toggle">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </span>
                  </div>
                  <ul className={`dropdown-content ${openDropdown === link.label ? "open" : "closed"}`}>
                    {link.subLinks.map((subLink) => (
                      <li key={subLink.label} className="submenu">
                        <Link to={subLink.path} onClick={closeMenu}>{subLink.label}</Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link to={link.path} onClick={closeMenu} >{link.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default MobileNavbar;
